/* =====================================================================
   ms-events.js
   Ergaenzung zu den serverseitig gerenderten Terminen auf /pages/events
   (sections/ms-events.liquid) und im Eventband der Startseite
   (sections/ms-home.liquid).

   UMGEBAUT AM 19.09.2026
   ----------------------
   Bis zum 19.09.2026 holte diese Datei die Termine im Browser aus
   Supabase (POST rest/v1/rpc/events) und baute Karte und Kachel selbst;
   ohne JavaScript stand nichts auf der Seite. Gemessen am 19.09.2026 um
   22:05 am ausgelieferten HTML: 0 Karten, 0 Kacheln, 0 Event-Knoten in
   allen drei Sprachen. Seither rendert Liquid alles aus den Metaobjekten
   "event" (tools/events_spiegeln.py spiegelt public.ms_event stuendlich
   dorthin, snippets/ms-event-karte.liquid baut Karte und Kachel,
   snippets/ms-event-ld.liquid das JSON-LD).

   WAS DIESE DATEI NOCH TUT, UND WARUM
   -----------------------------------
   Genau eines: Karten ausblenden, deren Termin nach der Uhr des Gastes
   vorbei ist. Shopify speichert die gerenderte Seite, der Spiegel laeuft
   stuendlich, und "vorbei" heisst seit dem 20.09.2026 wie in
   gast.events() (0107): ab Mitternacht Europe/Rome nach dem Endtag,
   Endtag ist endet_am, sonst beginnt_am (bis dahin: beginnt_am plus 24
   Stunden, 0058). Die Tagesgrenze ist die Bozner, nicht die des Gastes:
   das Datum steht im ISO-Text schon in Bozner Zeit (2026-11-12T18:15:00
   +01:00), verglichen wird mit dem heutigen Datum in Europe/Rome per
   Intl. Zwischen zwei Laeufen stuende ein
   Termin von gestern sonst bis zu einer Stunde laenger da. Bleibt in
   einer Wurzel nichts uebrig: die Eventseite zeigt den Satz aus
   data-t-leer, das Band der Startseite nimmt sich aus der Seite
   (data-ms-leer="verbergen", seit dem 17.09.2026: weg statt leer).

   Kein fetch mehr, kein Schluessel, keine Sprachlogik, keine Bedingung
   fuer Sichtbarkeit: ohne JavaScript steht die Seite vollstaendig.

   WURZELN UND IHRE ATTRIBUTE
   --------------------------
   Eine Wurzel ist jedes Element mit data-ms-events. Je Karte oder Kachel
   [data-ev-item] mit data-ev-beginn (ISO 8601 mit Versatz) und, falls
   gesetzt, data-ev-ende. Freiwillig an der Wurzel:
     data-ms-leer="verbergen"   bei null Terminen die Wurzel verbergen
     data-t-leer                Satz bei null Terminen (Eventseite)
     [data-ev-liste]            das Raster; fehlt es, ist die Wurzel das
                                Raster

   ZUSTAND FUER MESSUNGEN
   ----------------------
   data-ms-stand setzt Liquid (Zahl oder 'leer'); diese Datei setzt
   data-ms-anzahl nach dem Ausblenden neu und data-ms-js="gelaufen".
   ===================================================================== */
(function () {
  /* Heutiges Datum in Bozen als YYYY-MM-DD (sv-SE schreibt ISO). Faellt
     Intl mit Zeitzone aus (sehr alte Browser), bleibt es beim Datum des
     Gastes; der Spiegel raeumt spaetestens eine Stunde danach auf. */
  function heuteBozen() {
    try {
      return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Rome' }).format(new Date());
    } catch (e) {
      var d = new Date();
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }
  }

  function vorbei(el, heute) {
    var ende = el.getAttribute('data-ev-ende') || el.getAttribute('data-ev-beginn');
    if (!ende || ende.length < 10) { return false; }
    var endTag = ende.slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(endTag)) { return false; }
    /* ISO-Daten vergleichen sich als Text richtig. */
    return endTag < heute;
  }

  function init(wurzel) {
    var ziel = wurzel.querySelector('[data-ev-liste]') || wurzel;
    var heute = heuteBozen();
    var karten = wurzel.querySelectorAll('[data-ev-item]');
    var uebrig = 0;
    for (var i = 0; i < karten.length; i++) {
      if (vorbei(karten[i], heute)) {
        karten[i].parentNode.removeChild(karten[i]);
      } else {
        uebrig += 1;
      }
    }
    wurzel.setAttribute('data-ms-anzahl', String(uebrig));
    wurzel.setAttribute('data-ms-js', 'gelaufen');
    if (uebrig > 0) { return; }
    if (wurzel.getAttribute('data-ms-leer') === 'verbergen') {
      wurzel.hidden = true;
      return;
    }
    if (!ziel.querySelector('[data-ev-leer]')) {
      var p = document.createElement('p');
      p.className = 'ev-hinweis';
      p.setAttribute('data-ev-leer', '');
      p.textContent = wurzel.getAttribute('data-t-leer') || '';
      ziel.appendChild(p);
    }
  }

  function alle() {
    var wurzeln = document.querySelectorAll('[data-ms-events]');
    for (var i = 0; i < wurzeln.length; i++) { init(wurzeln[i]); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }
  document.addEventListener('shopify:section:load', alle);
})();
